@if (params.isEditing()) {
  @let context = params.editContext();

  <ng-select
    [(ngModel)]="context[params.node.rowIndex].selectedTrial"
    [items]="[0, 30, 60]"
    class="w-full"
    placeholder="Trial..."
    appendTo="body"
    [clearable]="true"
    [disabled]="!context[params.node.rowIndex].selectedPriceId || params.isSaving()"
  >
    <ng-template ng-label-tmp let-item="item" let-index="index"> Add {{ item }}... </ng-template>

    <ng-template ng-option-tmp let-item="item" let-index="index"> Add {{ item }} Days </ng-template>
  </ng-select>
} @else {
  <div [matTooltip]="getTrial(params.data.trialEnd).tooltip">
    {{ getTrial(params.data.trialEnd).text }}
  </div>
}
